import React, { Component } from "react";
import { List, Segment } from "semantic-ui-react";

class EmployeeOtherInfo extends Component {
  render() {
    let { others } = this.props;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Other Information</h1>
          <List className="userDataList">
            <List.Item>
              <label className="titleLabel">National Tax Number:</label>
              <label>
                {others.NTN}
              </label>
            </List.Item>
            <List.Item>
              <label className="titleLabel">EOBI:</label>
              <label>
                {others.EOBI}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Passport Number:</label>
              <label>
                {others.PassportNumber}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Blood Group:</label>
              <label>
                {others.BloodGroup}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Disability:</label>
              <label>
                {others.Disability ? others.DisabilityDescription : "No"}
                {others.Disability}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Availed Facilities:</label>
              <label>
                {others.MedicalInsurance
                  ? "Medical Insurance (Spouse/Kids), "
                  : ""}
              </label>
              <label>
                {others.LeaveEncashment ? "Leave Encashment (5 days), " : ""}
              </label>
              <label>
                {others.WeddingLeaves ? "Wedding Leaves, " : ""}
              </label>
              <label>
                {others.FamilyOPD ? "Family OPD" : ""}
              </label>
            </List.Item>
          </List>
        </Segment>
      </Segment.Group>
    );
  }
}

export default EmployeeOtherInfo;
